import { Firebase } from "../firebase";

export async function resetCacheAndReloadPage(messageCallback?: () => void) {
    await Firebase.instance().resetFirestore();
    messageCallback?.();
    location.reload();
}